export default function MinimalLayout( {children} ) {
    return (
        <>
            { children }
        </>
    );
}
